// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userSetupStatusStyles } from "@awc/Overrides/Widgets/UserSetup/UserSetupStatus";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

userSetupStatusStyles.title = {
    variant: "h5",
    css: css`
        padding-bottom: 10px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 14px;
    `,
};

userSetupStatusStyles.lastSignInTextField = {
    cssOverrides: {
        formInputWrapper: css`
            width: 60%;
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    labelProps: {
        css: css`
            width: 40%;
            text-align: left;
        `,
    },
};

userSetupStatusStyles.activationStatus = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        weight: fontConfig.weight.bold,
        color: "text",
        css: css`
            width: 40%;
            ${xScreen("lte", "sm")} {
                width: auto;
            }
        `,
    },
    css: css`
        justify-content: start;
        ${xScreen("lte", "sm")} {
            ${IconWrapper} {
                margin-left: 5%;
            }
        }
    `,
};
